// tslint:disable:no-var-requires
const conditionsData = require('../data/conditions.json');
// tslint:enable:no-var-requires

export const Condition = (name: string, placeholder?: string, replacement?: string) => {
  if (placeholder && replacement) {
    const data = conditionsData[name];
    if (data) {
      data.description = data.description.replace(placeholder, replacement);
    }
    // data.description = data.description.replace('--dynamicClauseGAS--', paymentConditionReplaceText.gas);
    // data.description = data.description.replace('--dynamicClauseLUCE--', paymentConditionReplaceText.luce);
    // data.description = data.description.replace('--dynamicClauseDUAL--', paymentConditionReplaceText.lucegas);

    return data;
  }
  return conditionsData[name];
};

const paymentConditionReplaceText = {
  gas: 'dichiara di conoscere che la garanzia dei pagamenti cui all’art. 8 della Condizioni generali di fornitura di gas naturale è richiesta ai soli clienti non soci all’atto di attivazione della fornitura',
  lucegas:
    'dichiara di conoscere che la garanzia dei pagamenti cui all’art. 8 della Condizioni generali di fornitura di energia elettrica e gas è richiesta ai soli clienti non soci all’atto di attivazione della fornitura',
  luce: 'dichiara di conoscere che la garanzia dei pagamenti cui all’art. 8 della Condizioni generali di fornitura di energia elettrica è richiesta ai soli clienti non soci all’atto di attivazione della fornitura ',
};

export const paymentConditionTypeToReplace = [
  'consenti1',
  'consenti2',
  'consenti3',
  'consensoVeloceConsent1',
  'consensoVeloceConsent2',
  'consensoVeloceConsent3',
  'consensoVeloceUnipolConsent1',
  'consensoVeloceUnipolConsent2',
  'consensoVeloceUnipolConsent3',
];

export const conditionTextList = {
  cadastral: Condition('catastali'),
  clause: {
    '*': Condition('clausole_general'),
    // Clausole 1
    'casa-online-luce-gas-24-mesi-bi': Condition('clausole1'),
    'casa-online-luce-gas-12-mesi-bi': Condition('clausole1'),
    'casa-online-luce-gas-24-mesi-mono': Condition('clausole1'),
    'casa-online-luce-gas-12-mesi-mono': Condition('clausole1'),
    'ecologica-luce-gas-24-mesi-bi': Condition('clausole1'),
    'ecologica-luce-gas-12-mesi-bi': Condition('clausole1'),
    'ecologica-luce-gas-24-mesi-mono': Condition('clausole1'),
    'ecologica-luce-gas-12-mesi-mono': Condition('clausole1'),
    'seconda-casa-luce-gas-24-mesi-mono': Condition('clausole1'),
    'futura-luce-gas-24-mesi-bi': Condition('clausole1'),
    'futura-luce-gas-24-mesi-mono': Condition('clausole1'),
    // Clausole 2
    'casa-online-luce-24-mesi-bi': Condition('clausole2'),
    'casa-online-luce-12-mesi-bi': Condition('clausole2'),
    'casa-online-luce-24-mesi-mono': Condition('clausole2'),
    'casa-online-luce-12-mesi-mono': Condition('clausole2'),
    'ecologica-luce-24-mesi-bi': Condition('clausole2'),
    'ecologica-luce-12-mesi-bi': Condition('clausole2'),
    'ecologica-luce-24-mesi-mono': Condition('clausole2'),
    'ecologica-luce-12-mesi-mono': Condition('clausole2'),
    'seconda-casa-luce-24-mesi-mono': Condition('clausole2'),
    'futura-luce-24-mesi-bi': Condition('clausole2'),
    'futura-luce-24-mesi-mono': Condition('clausole2'),
    'casa-luce-24-mesi-bi': Condition('clausole2'),
    'casa-luce-24-mesi-mono': Condition('clausole2'),
    'casa-luce-gas-24-mesi-bi': Condition('clausole2'),
    // Clausole 3
    'casa-online-gas-24-mesi': Condition('clausole3'),
    'casa-online-gas-12-mesi': Condition('clausole3'),
    'seconda-casa-gas-24-mesi': Condition('clausole3'),
    'futura-gas-24-mesi': Condition('clausole3'),
    'ecologica-gas-24-mesi': Condition('clausole3'),
    'ecologica-gas-12-mesi': Condition('clausole3'),
    // Clausole 4
    'placet-fissa-luce-domestico': Condition('clausole4'),
    'placet-variabile-luce-domestico': Condition('clausole4'),
    // Clausole 5
    'placet-fissa-gas-domestico': Condition('clausole5'),
    'placet-variabile-gas-domestico': Condition('clausole5'),
  },
  consents: {
    '*': Condition('consenti_general'),
    // Consenti 1
    'casa-online-luce-gas-24-mesi-bi': Condition('consenti1'),
    'casa-online-luce-gas-12-mesi-bi': Condition('consenti1'),
    'casa-online-luce-gas-24-mesi-mono': Condition('consenti1'),
    'casa-online-luce-gas-12-mesi-mono': Condition('consenti1'),
    'ecologica-luce-gas-24-mesi-bi': Condition('consenti1'),
    'ecologica-luce-gas-12-mesi-bi': Condition('consenti1'),
    'ecologica-luce-gas-24-mesi-mono': Condition('consenti1'),
    'ecologica-luce-gas-12-mesi-mono': Condition('consenti1'),
    'seconda-casa-luce-gas-24-mesi-mono': Condition('consenti1'),
    'futura-luce-gas-24-mesi-bi': Condition('consenti1'),
    'futura-luce-gas-24-mesi-mono': Condition('consenti1'),
    'casa-online-luce-gas-24-mesi-bi-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'casa-online-luce-gas-12-mesi-bi-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'casa-online-luce-gas-24-mesi-mono-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'casa-online-luce-gas-12-mesi-mono-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'ecologica-luce-gas-24-mesi-bi-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'ecologica-luce-gas-12-mesi-bi-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'ecologica-luce-gas-24-mesi-mono-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'ecologica-luce-gas-12-mesi-mono-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'seconda-casa-luce-gas-24-mesi-mono-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'futura-luce-gas-24-mesi-bi-VULNERABILI': Condition('consenti1-VULNERABILI'),
    'futura-luce-gas-24-mesi-mono-VULNERABILI': Condition('consenti1-VULNERABILI'),
    // Consenti 2
    'casa-online-luce-24-mesi-bi': Condition('consenti2'),
    'casa-online-luce-12-mesi-bi': Condition('consenti2'),
    'casa-online-luce-24-mesi-mono': Condition('consenti2'),
    'casa-online-luce-12-mesi-mono': Condition('consenti2'),
    'ecologica-luce-24-mesi-bi': Condition('consenti2'),
    'ecologica-luce-12-mesi-bi': Condition('consenti2'),
    'ecologica-luce-24-mesi-mono': Condition('consenti2'),
    'ecologica-luce-12-mesi-mono': Condition('consenti2'),
    'seconda-casa-luce-24-mesi-mono': Condition('consenti2'),
    'futura-luce-24-mesi-bi': Condition('consenti2'),
    'futura-luce-24-mesi-mono': Condition('consenti2'),
    'casa-luce-24-mesi-bi': Condition('consenti2'),
    'casa-luce-24-mesi-mono': Condition('consenti2'),
    'casa-luce-gas-24-mesi-bi': Condition('consenti2'),

    'casa-online-luce-24-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'casa-online-luce-12-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'casa-online-luce-24-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'casa-online-luce-12-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'ecologica-luce-24-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'ecologica-luce-12-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'ecologica-luce-24-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'ecologica-luce-12-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'seconda-casa-luce-24-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'futura-luce-24-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'futura-luce-24-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'casa-luce-24-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'casa-luce-24-mesi-mono-VULNERABILI': Condition('consenti2-VULNERABILI'),
    'casa-luce-gas-24-mesi-bi-VULNERABILI': Condition('consenti2-VULNERABILI'),
    // Consenti 3
    'casa-online-gas-24-mesi': Condition('consenti3'),
    'casa-online-gas-12-mesi': Condition('consenti3'),
    'seconda-casa-gas-24-mesi': Condition('consenti3'),
    'futura-gas-24-mesi': Condition('consenti3'),
    'ecologica-gas-24-mesi': Condition('consenti3'),
    'ecologica-gas-12-mesi': Condition('consenti3'),

    'casa-online-gas-24-mesi-VULNERABILI': Condition('consenti3-VULNERABILI'),
    'casa-online-gas-12-mesi-VULNERABILI': Condition('consenti3-VULNERABILI'),
    'seconda-casa-gas-24-mesi-VULNERABILI': Condition('consenti3-VULNERABILI'),
    'futura-gas-24-mesi-VULNERABILI': Condition('consenti3-VULNERABILI'),
    'ecologica-gas-24-mesi-VULNERABILI': Condition('consenti3-VULNERABILI'),
    'ecologica-gas-12-mesi-VULNERABILI': Condition('consenti3-VULNERABILI'),
    // Consenti 4
    'placet-fissa-luce-domestico': Condition('consenti4'),
    'placet-variabile-luce-domestico': Condition('consenti4'),
    // Consenti 5
    'placet-fissa-gas-domestico': Condition('consenti5'),
    'placet-variabile-gas-domestico': Condition('consenti5'),
    // nuovi consensi
    'clauseCondition-GAS-NO_PLACET': Condition('clauseCondition-GAS-NO_PLACET', '--dynamicText--', "nell'articolo 2.3 delle"),
    'clauseCondition-GAS-NO_PLACET-VULNERABILI': Condition('clauseCondition-GAS-NO_PLACET-VULNERABILI', '--dynamicText--', "nell'articolo 5.4 delle"),
    'clauseCondition-LUCE-NO_PLACET': Condition('clauseCondition-LUCE-NO_PLACET', '--dynamicText--', "nell'articolo 2.3 delle"),
    'clauseCondition-LUCE-NO_PLACET-VULNERABILI': Condition('clauseCondition-LUCE-NO_PLACET-VULNERABILI', '--dynamicText--', "nell'articolo 5.4 delle"),
    'clauseCondition-DUAL-NO_PLACET': Condition('clauseCondition-DUAL-NO_PLACET', '--dynamicText--', "nell'articolo 2.3 delle"),
    'clauseCondition-DUAL-NO_PLACET-VULNERABILI': Condition('clauseCondition-DUAL-NO_PLACET-VULNERABILI', '--dynamicText--', "nell'articolo 5.4 delle"),
    'clauseCondition-GAS-PLACET': Condition('clauseCondition-GAS-PLACET', '--dynamicText--', "nell'articolo 5.5 delle"),
    'clauseCondition-LUCE-PLACET': Condition('clauseCondition-LUCE-PLACET', '--dynamicText--', "nell'articolo 5.5 delle"),

    'OnbClauseCondition-GAS-NO_PLACET': Condition('OnbClauseCondition-GAS-NO_PLACET', '--dynamicText--', "nell'articolo 2.3 delle"),
    'OnbClauseCondition-GAS-NO_PLACET-VULNERABILI': Condition('OnbClauseCondition-GAS-NO_PLACET-VULNERABILI', '--dynamicText--', "nell'articolo 5.4 delle"),
    'OnbClauseCondition-LUCE-NO_PLACET': Condition('OnbClauseCondition-LUCE-NO_PLACET', '--dynamicText--', "nell'articolo 2.3 delle"),
    'OnbClauseCondition-LUCE-NO_PLACET-VULNERABILI': Condition('OnbClauseCondition-LUCE-NO_PLACET-VULNERABILI', '--dynamicText--', "nell'articolo 5.4 delle"),
    'OnbClauseCondition-DUAL-NO_PLACET': Condition('OnbClauseCondition-DUAL-NO_PLACET', '--dynamicText--', "nell'articolo 2.3 delle"),
    'OnbClauseCondition-DUAL-NO_PLACET-VULNERABILI': Condition('OnbClauseCondition-DUAL-NO_PLACET-VULNERABILI', '--dynamicText--', "nell'articolo 5.4 delle"),
    'OnbClauseCondition-GAS-PLACET': Condition('OnbClauseCondition-GAS-PLACET', '--dynamicText--', "nell'articolo 5.5 delle"),
    'OnbClauseCondition-LUCE-PLACET': Condition('OnbClauseCondition-LUCE-PLACET', '--dynamicText--', "nell'articolo 5.5 delle"),
    'OnbClauseCondition-DUAL-PLACET': Condition('OnbClauseCondition-DUAL-PLACET', '--dynamicText--', "nell'articolo 5.5 delle"),
    'cadastralsCondition-DUAL': Condition('cadastralsCondition-DUAL'),
    'cadastralsCondition-LUCE': Condition('cadastralsCondition-LUCE'),
    'cadastralsCondition-GAS': Condition('cadastralsCondition-GAS'),
    'cadastralsCondition-GAS-PLACET': Condition('cadastralsCondition-GAS-PLACET'),
    'cadastralsCondition-LUCE-PLACET': Condition('cadastralsCondition-LUCE-PLACET'),
  },
  helper: {
    attivazioneVeloce: Condition('attivazioneVeloce'),
    attivazioneVelocePLACET: Condition('attivazioneVeloce-PLACET'),
    attivazioneVeloceVULNERABILI: Condition('attivazioneVeloce-VULNERABILI'),
  },
};

export const consensoVeloceConditionsText = {
  cadastral: Condition('catastali'),
  clause: new Map([
    [0, Condition('clausole_general')], // Fallback
    [1111, Condition('clausole2')], // Casa, Luce, 12 Mesi, Fisso
    [1121, Condition('clausole2')], // Casa, Luce, 24 Mesi, Fisso
    [1211, Condition('clausole3')], // Casa, Gas, 12 Mesi, Fisso
    [1221, Condition('clausole3')], // Casa, Gas, 24 Mesi, Fisso
    [1311, Condition('clausole1')], // Casa, Luce & Gas, 12 Mesi, Fisso
    [1321, Condition('clausole1')], // Casa, Luce & Gas, 24 Mesi, Fisso
    [2121, Condition('clausole2')], // Seconda Casa, Luce, 24 Mesi, Fisso
    [2221, Condition('clausole3')], // Seconda Casa, Gas, 24 Mesi, Fisso
    [2321, Condition('clausole1')], // Seconda Casa, Luce & Gas, 24 Mesi, Fisso
    [3111, Condition('clausole4')], // Placet, Luce, 12 Mesi, Fisso
    [3112, Condition('clausole4')], // Placet, Luce, 12 Mesi, Variabile
    [3211, Condition('clausole5')], // Placet, Gas, 12 Mesi, Fisso
    [3212, Condition('clausole5')], // Placet, Gas, 12 Mesi, Variabile
    [4121, Condition('clausole2')], // Futura, Luce, 24 Mesi, Fisso
    [4221, Condition('clausole3')], // Futura, Gas, 24 Mesi, Fisso
    [4321, Condition('clausole1')], // Futura, Luce & Gas, 24 Mesi, Fisso

    [5111, Condition('clausole2')], // Ecologica, Luce, 12 Mesi, Fisso
    [5121, Condition('clausole2')], // Ecologica, Luce, 24 Mesi, Fisso
    [5211, Condition('clausole3')], // Ecologica, Gas, 12 Mesi, Fisso
    [5221, Condition('clausole3')], // Ecologica, Gas, 24 Mesi, Fisso
    [5311, Condition('clausole1')], // Ecologica, Luce & Gas, 12 Mesi, Fisso
    [5321, Condition('clausole1')], // Ecologica, Luce & Gas, 24 Mesi, Fisso
  ]),
  consentsUnipol: new Map([
    [0, Condition('consenti_general')], // Fallback
    [1111, Condition('consensoVeloceUnipolConsent2')], // Casa, Luce, 12 Mesi, Fisso
    [1121, Condition('consensoVeloceUnipolConsent2')], // Casa, Luce, 24 Mesi, Fisso
    [1211, Condition('consensoVeloceUnipolConsent3')], // Casa, Gas, 12 Mesi, Fisso
    [1221, Condition('consensoVeloceUnipolConsent3')], // Casa, Gas, 24 Mesi, Fisso
    [1311, Condition('consensoVeloceUnipolConsent1')], // Casa, Luce & Gas, 12 Mesi, Fisso
    [1321, Condition('consensoVeloceUnipolConsent1')], // Casa, Luce & Gas, 24 Mesi, Fisso
    [2121, Condition('consensoVeloceUnipolConsent2')], // Seconda Casa, Luce, 24 Mesi, Fisso
    [2221, Condition('consensoVeloceUnipolConsent3')], // Seconda Casa, Gas, 24 Mesi, Fisso
    [2321, Condition('consensoVeloceUnipolConsent1')], // Seconda Casa, Luce & Gas, 24 Mesi, Fisso
    [3111, Condition('consensoVeloceUnipolConsent4')], // Placet, Luce, 12 Mesi, Fisso
    [3112, Condition('consensoVeloceUnipolConsent4')], // Placet, Luce, 12 Mesi, Variabile
    [3211, Condition('consensoVeloceUnipolConsent5')], // Placet, Gas, 12 Mesi, Fisso
    [3212, Condition('consensoVeloceUnipolConsent5')], // Placet, Gas, 12 Mesi, Variabile
    [4121, Condition('consensoVeloceUnipolConsent2')], // Futura, Luce, 24 Mesi, Fisso
    [4221, Condition('consensoVeloceUnipolConsent3')], // Futura, Gas, 24 Mesi, Fisso
    [4321, Condition('consensoVeloceUnipolConsent1')], // Futura, Luce & Gas, 24 Mesi, Fisso

    [5111, Condition('consensoVeloceUnipolConsent2')], // Ecologica, Luce, 12 Mesi, Fisso
    [5121, Condition('consensoVeloceUnipolConsent2')], // Ecologica, Luce, 24 Mesi, Fisso
    [5211, Condition('consensoVeloceUnipolConsent3')], // Ecologica, Gas, 12 Mesi, Fisso
    [5221, Condition('consensoVeloceUnipolConsent3')], // Ecologica, Gas, 24 Mesi, Fisso
    [5311, Condition('consensoVeloceUnipolConsent1')], // Ecologica, Luce & Gas, 12 Mesi, Fisso
    [5321, Condition('consensoVeloceUnipolConsent1')], // Ecologica, Luce & Gas, 24 Mesi, Fisso

    [91111, Condition('consensoVeloceUnipolConsent2-VULNERABILI')], // Casa, Luce, 12 Mesi, Fisso
    [91121, Condition('consensoVeloceUnipolConsent2-VULNERABILI')], // Casa, Luce, 24 Mesi, Fisso
    [91211, Condition('consensoVeloceUnipolConsent3-VULNERABILI')], // Casa, Gas, 12 Mesi, Fisso
    [91221, Condition('consensoVeloceUnipolConsent3-VULNERABILI')], // Casa, Gas, 24 Mesi, Fisso
    [91311, Condition('consensoVeloceUnipolConsent1-VULNERABILI')], // Casa, Luce & Gas, 12 Mesi, Fisso
    [91321, Condition('consensoVeloceUnipolConsent1-VULNERABILI')], // Casa, Luce & Gas, 24 Mesi, Fisso
    [92121, Condition('consensoVeloceUnipolConsent2-VULNERABILI')], // Seconda Casa, Luce, 24 Mesi, Fisso
    [92221, Condition('consensoVeloceUnipolConsent3-VULNERABILI')], // Seconda Casa, Gas, 24 Mesi, Fisso
    [92321, Condition('consensoVeloceUnipolConsent1-VULNERABILI')], // Seconda Casa, Luce & Gas, 24 Mesi, Fisso
    [94121, Condition('consensoVeloceUnipolConsent2-VULNERABILI')], // Futura, Luce, 24 Mesi, Fisso
    [94221, Condition('consensoVeloceUnipolConsent3-VULNERABILI')], // Futura, Gas, 24 Mesi, Fisso
    [94321, Condition('consensoVeloceUnipolConsent1-VULNERABILI')], // Futura, Luce & Gas, 24 Mesi, Fisso

    [95111, Condition('consensoVeloceUnipolConsent2-VULNERABILI')], // Ecologica, Luce, 12 Mesi, Fisso
    [95121, Condition('consensoVeloceUnipolConsent2-VULNERABILI')], // Ecologica, Luce, 24 Mesi, Fisso
    [95211, Condition('consensoVeloceUnipolConsent3-VULNERABILI')], // Ecologica, Gas, 12 Mesi, Fisso
    [95221, Condition('consensoVeloceUnipolConsent3-VULNERABILI')], // Ecologica, Gas, 24 Mesi, Fisso
    [95311, Condition('consensoVeloceUnipolConsent1-VULNERABILI')], // Ecologica, Luce & Gas, 12 Mesi, Fisso
    [95321, Condition('consensoVeloceUnipolConsent1-VULNERABILI')], // Ecologica, Luce & Gas, 24 Mesi, Fisso
  ]),
  consents: new Map([
    [0, Condition('consenti_general')], // Fallback
    [1111, Condition('consensoVeloceConsent2')], // Casa, Luce, 12 Mesi, Fisso
    [1121, Condition('consensoVeloceConsent2')], // Casa, Luce, 24 Mesi, Fisso
    [1211, Condition('consensoVeloceConsent3')], // Casa, Gas, 12 Mesi, Fisso
    [1221, Condition('consensoVeloceConsent3')], // Casa, Gas, 24 Mesi, Fisso
    [1311, Condition('consensoVeloceConsent1')], // Casa, Luce & Gas, 12 Mesi, Fisso
    [1321, Condition('consensoVeloceConsent1')], // Casa, Luce & Gas, 24 Mesi, Fisso
    [2121, Condition('consensoVeloceConsent2')], // Seconda Casa, Luce, 24 Mesi, Fisso
    [2221, Condition('consensoVeloceConsent3')], // Seconda Casa, Gas, 24 Mesi, Fisso
    [2321, Condition('consensoVeloceConsent1')], // Seconda Casa, Luce & Gas, 24 Mesi, Fisso
    [3111, Condition('consensoVeloceConsent4')], // Placet, Luce, 12 Mesi, Fisso
    [3112, Condition('consensoVeloceConsent4')], // Placet, Luce, 12 Mesi, Variabile
    [3211, Condition('consensoVeloceConsent5')], // Placet, Gas, 12 Mesi, Fisso
    [3212, Condition('consensoVeloceConsent5')], // Placet, Gas, 12 Mesi, Variabile
    [4121, Condition('consensoVeloceConsent2')], // Futura, Luce, 24 Mesi, Fisso
    [4221, Condition('consensoVeloceConsent3')], // Futura, Gas, 24 Mesi, Fisso
    [4321, Condition('consensoVeloceConsent1')], // Futura, Luce & Gas, 24 Mesi, Fisso

    [5111, Condition('consensoVeloceConsent2')], // Ecologica, Luce, 12 Mesi, Fisso
    [5121, Condition('consensoVeloceConsent2')], // Ecologica, Luce, 24 Mesi, Fisso
    [5211, Condition('consensoVeloceConsent3')], // Ecologica, Gas, 12 Mesi, Fisso
    [5221, Condition('consensoVeloceConsent3')], // Ecologica, Gas, 24 Mesi, Fisso
    [5311, Condition('consensoVeloceConsent1')], // Ecologica, Luce & Gas, 12 Mesi, Fisso
    [5321, Condition('consensoVeloceConsent1')], // Ecologica, Luce & Gas, 24 Mesi, Fisso

    [91111, Condition('consensoVeloceConsent2-VULNERABILI')], // Casa, Luce, 12 Mesi, Fisso
    [91121, Condition('consensoVeloceConsent2-VULNERABILI')], // Casa, Luce, 24 Mesi, Fisso
    [91211, Condition('consensoVeloceConsent3-VULNERABILI')], // Casa, Gas, 12 Mesi, Fisso
    [91221, Condition('consensoVeloceConsent3-VULNERABILI')], // Casa, Gas, 24 Mesi, Fisso
    [91311, Condition('consensoVeloceConsent1-VULNERABILI')], // Casa, Luce & Gas, 12 Mesi, Fisso
    [91321, Condition('consensoVeloceConsent1-VULNERABILI')], // Casa, Luce & Gas, 24 Mesi, Fisso
    [92121, Condition('consensoVeloceConsent2-VULNERABILI')], // Seconda Casa, Luce, 24 Mesi, Fisso
    [92221, Condition('consensoVeloceConsent3-VULNERABILI')], // Seconda Casa, Gas, 24 Mesi, Fisso
    [92321, Condition('consensoVeloceConsent1-VULNERABILI')], // Seconda Casa, Luce & Gas, 24 Mesi, Fisso
    [94121, Condition('consensoVeloceConsent2-VULNERABILI')], // Futura, Luce, 24 Mesi, Fisso
    [94221, Condition('consensoVeloceConsent3-VULNERABILI')], // Futura, Gas, 24 Mesi, Fisso
    [94321, Condition('consensoVeloceConsent1-VULNERABILI')], // Futura, Luce & Gas, 24 Mesi, Fisso

    [95111, Condition('consensoVeloceConsent2-VULNERABILI')], // Ecologica, Luce, 12 Mesi, Fisso
    [95121, Condition('consensoVeloceConsent2-VULNERABILI')], // Ecologica, Luce, 24 Mesi, Fisso
    [95211, Condition('consensoVeloceConsent3-VULNERABILI')], // Ecologica, Gas, 12 Mesi, Fisso
    [95221, Condition('consensoVeloceConsent3-VULNERABILI')], // Ecologica, Gas, 24 Mesi, Fisso
    [95311, Condition('consensoVeloceConsent1-VULNERABILI')], // Ecologica, Luce & Gas, 12 Mesi, Fisso
    [95321, Condition('consensoVeloceConsent1-VULNERABILI')], // Ecologica, Luce & Gas, 24 Mesi, Fisso
  ]),
  helper: {
    attivazioneVeloce: Condition('attivazioneVeloce'),
    attivazioneVelocePLACET: Condition('attivazioneVeloce-PLACET'),
    attivazioneVeloceVULNERABILI: Condition('attivazioneVeloce-VULNERABILI'),
  },
};

export const declerationLinearText = {
  light: Condition('decleration-options-LIGHT'),
  gas: Condition('decleration-options-GAS'),
  clausoleGas: Condition('decleration-options-clausole-GAS'),
  clausoleLight: Condition('decleration-options-clausole-LIGHT'),
  greenEnergy: Condition('decleration-GREEN'),
};



// WEBPACK FOOTER //
// ./src/app/models/contitions.ts